import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['widgetType', 'groupBy', 'groupByFields', 'calendarFields', 'eventTitleField', 'startDateField', 'endDateField']

  declare readonly widgetTypeTarget: HTMLSelectElement
  declare readonly groupByTarget: HTMLInputElement
  declare readonly hasGroupByFieldsTarget: boolean
  declare readonly groupByFieldsTarget: HTMLElement
  declare readonly hasCalendarFieldsTarget: boolean
  declare readonly calendarFieldsTarget: HTMLElement
  declare readonly hasEventTitleFieldTarget: boolean
  declare readonly eventTitleFieldTarget: HTMLSelectElement
  declare readonly hasStartDateFieldTarget: boolean
  declare readonly startDateFieldTarget: HTMLSelectElement
  declare readonly hasEndDateFieldTarget: boolean
  declare readonly endDateFieldTarget: HTMLSelectElement

  initialize (): void {
    this.changeType()
  }

  changeType (): void {
    const type = this.widgetTypeTarget.value
    const isNumber = type === 'number'
    const isCalendar = type === 'calendar'
    const showGroupBy = !isNumber && !isCalendar

    this.groupByTarget.disabled = !showGroupBy

    if (this.hasGroupByFieldsTarget) {
      this.groupByFieldsTarget.classList.toggle('hidden', !showGroupBy)
    }

    if (this.hasCalendarFieldsTarget) {
      this.calendarFieldsTarget.classList.toggle('hidden', !isCalendar)
    }

    this.setCalendarFieldsDisabled(!isCalendar)
  }

  setCalendarFieldsDisabled (disabled: boolean): void {
    if (this.hasEventTitleFieldTarget) this.eventTitleFieldTarget.disabled = disabled
    if (this.hasStartDateFieldTarget) this.startDateFieldTarget.disabled = disabled
    if (this.hasEndDateFieldTarget) this.endDateFieldTarget.disabled = disabled
  }

  reset (): void {
    (this.element as HTMLFormElement).reset()
    this.changeType()
  }
}
